// UPDATE PLUGINS
export const UPDATE_PLUGINS = 'UPDATE_PLUGINS';
